import AxiosConfig from '../../../config/AxiosConfig';

const useResentPaymentLink = () => {
  const resentPaymentLink = async (orderRef, data) => {
    try {
      const response = await AxiosConfig.create(
        'post',
        `/orders/sav/${orderRef}/resentPaymentLink`
      )
        .call(data)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to resent payment link:', err);
      throw new Error(`Failed to resent payment link: ${err.message}`);
    }
  };

  return {
    resentPaymentLink,
  };
};

export default useResentPaymentLink;
